const initialState = {
  currentId: null,
  isListModalOpen: false,
  isNameModalOpen: false,
  isQRModalOpen: false
}

const openOrder = (state = initialState, {type, payload}) => {
  switch (type) {
    case "OPEN_ORDER.CLOSE_LIST":
      return {...state, isListModalOpen: false}
    case "OPEN_ORDER.CLOSE_TITLE":
    case "OPEN_ORDER.CLEAR_CURRENT":
      return {...state, currentId: null}
    case "OPEN_ORDER.ITEM_CLICKED":
      return {...state, currentId: payload.id, isListModalOpen: false}
    case "OPEN_ORDER.NAME_CANCELLED":
      return {...state, isNameModalOpen: false}
    case "OPEN_ORDER.NAME_CONFIRMED":
      return {...state, isNameModalOpen: false}
    case "OPEN_ORDER.OPEN_LIST":
      return {...state, isListModalOpen: true}
    case "ORDER.TOUCHLESS_ORDER_CREATED":
      return {...state, isQRModalOpen: true, currentId: payload.openOrders[0].id}
    case "ORDER.TOUCHLESS_ORDER_CLOSED":
      return {...state, isQRModalOpen: false, currentId: null}
    case "PAYMENT_TYPE.OPEN_ORDER_CLICKED":
      return {...state, isNameModalOpen: true}
    default:
      return state
  }
}

export default openOrder
